skrilla.directive('userBets', function () {
    return {
        templateUrl: 'directives/userBets/userBets.html',
        scope: {
            user: "="
        },
        controller: function ($scope, searchService, queryService, paginationService, cacheService, srefService, modalService, adminService) {
            $scope.key = `userBets${$scope.user.id}`;
            $scope.queryKey = `queryBets${$scope.user.id}`;
            $scope.userBets = cacheService.getObjectOrElse(`${$scope.key}betsTable`, [])
            $scope.hasRole = adminService.hasRole;

            $scope.canCancel = function(){
                var userBets = $scope.tableData.data;
                if(userBets !== undefined && userBets.length > 0){
                    return userBets.some(function(bet){
                        return(!['CANCELLED', 'VOID', 'REJECTED'].includes(bet.status));
                    });
                }
                return false;
            }

            $scope.voidBets = function(){
                let userBets = $scope.tableData.data;
                let betsToVoid = userBets.filter(function(bet){
                    return !['CANCELLED', 'VOID', 'REJECTED'].includes(bet.status);
                });
                cacheService.registerObject("userBetsToVoid", betsToVoid);
                modalService.openModal("directives/userBets/voidUserBetsModal.html", true, 'lg', false, false, function(){
                });
            }
            $scope.tableData = {
                columns: [
                    {title: "Bet Name", field: "name"},
                    {title: "Entry Id", field: "entryId", filter: {func: (it) => { return `B-${it}`}}},
                    {title: "Selection Count", field: "selectionCount"},
                    {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                    {title: "Stake Source", field: "stakeSource"},
                    {title: "Odds", field: "odds"},
                    {title: "Potential Payout", field: "potentialPayout", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                    {title: "Payout", field: "paidOut", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                    {title: "Winnings", field: "winnings", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                    {title: "Status", field: "status"},
                    {title: "Result", field: "result"},
                    {title: "Currency", field: "currency"},
                    {title: "Rejection Reason", field: "reason"},
                    {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
                    {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
                    {title: "Updated By", field: "updatedBy"}
                ],
                rows: {orderBy: "-createdAt", onClick: clickRow},
                isSkrillaTable: true,
                data: $scope.userBets
            }
            function clickRow(bet, event){
                srefService.go("betDetails", {id: bet.id}, event);
            }
        }
    };
});
